var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkin-stepper',{attrs:{"step":3,"title":{ text: 'Get ready for', strongText: 'personalised recommendations' }},on:{"next":_vm.next}},[_c('ValidationObserver',{ref:"obs"},[_c('j-card',{staticClass:"pa-2"},[_c('personal-preferences',{ref:"preferences"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }